<template>
  <v-form ref="form" class="form">
    <h2>{{ $t("organizations.general-settings") }}</h2>
    <v-row>
      <v-col class="py-0" cols="6">
        <v-text-field
          v-model="organization.name"
          :label="$t('organizations.name')"
          :loading="resourceLoading"
          :rules="
            resourceLoading ? [] : [rules.required, backEndValidation('name')]
          "
          :readonly="readonly"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-btn
      color="primary mr-3"
      v-on:click="save()"
      :loading="loading"
      :disabled="readonly"
    >
      <v-icon left>{{ $props.button_icon }}</v-icon>
      {{ $t(`organizations.${$props.button_title}`) }}
    </v-btn>
  </v-form>
</template>

<script>
import { rules } from "../mixins/rules";
export default {
  name: "FormOrganization",
  mixins: [rules],
  data: () => ({
    loading: false
  }),
  props: {
    dispatch: String,
    button_title: String,
    button_icon: String,
    readonly: Boolean,
    organization: {
      default: function() {
        return {};
      }
    },
    resourceLoading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    save() {
      this.clearBackEndErrors();
      if (!this.readonly && this.$refs.form.validate()) {
        this.loading = true;
        let item = {
          ...this.organization
        };
        delete item.notices;
        this.$store
          .dispatch(this.$props.dispatch, {
            item,
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            }),
            onSuccess: item => {
              if (item) {
                this.$store.commit(
                  "organizationMeteringStore/meterUnitStore/set",
                  {
                    item
                  }
                );
                this.$router.push({
                  name: "organization",
                  params: {
                    id: item.id
                  }
                });
              }
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    maxLength(value) {
      return (
        (value || "").length <= 6 ||
        this.$t("organizations.rule-max-currency-length")
      );
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.factor {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .btn {
    flex: 0 0 36px;
    margin-left: 15px;
  }
  .name {
    flex: 1 1;
  }
  .factor {
    margin-left: 15px;
    flex: 0 0 100px;
  }
}
</style>
